import { DataProxy } from '@apollo/client'
import { GqlQuery } from '@broker-crm-utils'

import { CachedListUpdateStrategy, updateCachedItem, updateCachedList } from '@acre/utils'
import {
  AddClientMutation,
  GetClientOrganisationRelationshipsDocument,
  GetClientsDocument,
  GetCurrentUserQuery,
  Maybe,
  UpdateClientMutation,
  UpdateClientOrganisationRelationshipMutation,
} from '@acre/graphql'

export const updateClientCache = async (
  cache: DataProxy,
  data: UpdateClientMutation,
  clientId: string,
  getQuery: GqlQuery,
): Promise<UpdateClientMutation['updateClient']> => {
  const newClient: UpdateClientMutation['updateClient'] = data!.updateClient!
  const updatedClient = await updateCachedItem<UpdateClientMutation['updateClient']>(cache, {
    query: getQuery,
    variables: { id: clientId },
    data: newClient,
    key: 'client',
  })
  return updatedClient
}

export const updateClientListCache = async (
  cache: DataProxy,
  data: AddClientMutation,
  user: Maybe<GetCurrentUserQuery['currentUser']>,
) => {
  const { addClient } = data
  if (addClient && user && user.organisation) {
    await updateCachedList<AddClientMutation['addClient']>(cache, {
      readQuery: {
        query: GetClientsDocument,
        variables: { organisationId: user.organisation.id },
      },
      writeQuery: {
        query: GetClientsDocument,
        variables: { organisationId: user.organisation.id },
      },
      newItem: addClient,
      strategy: CachedListUpdateStrategy.Prepend,
      key: 'clients',
    })
  }
}

export const updateClientOrganisationRelationshipsCache = (
  cache: DataProxy,
  data: UpdateClientOrganisationRelationshipMutation,
  clientId: string,
) => {
  const { updateClientOrganisationRelationship } = data
  updateCachedItem<UpdateClientOrganisationRelationshipMutation['updateClientOrganisationRelationship']>(cache, {
    query: GetClientOrganisationRelationshipsDocument,
    variables: { client_id: clientId },
    data: updateClientOrganisationRelationship,
    key: 'clientOrganisationRelationships',
  })
}
